import { type IntlShape } from 'react-intl';

import { getUserRecommendations, type OptionData } from '@atlaskit/smart-user-picker';

type ProductKeyType = 'confluence' | 'jira';

type GetContributorsProps = {
	cloudId: string;
	intl: IntlShape;
	maxNumberOfResults: number;
	productKey: ProductKeyType;
	query: string;
	userId: string;
};

export const getContributors = ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetContributorsProps): Promise<OptionData[]> => {
	const requestParams = {
		context: {
			contextType: 'contributors',
			principalId: userId,
			productAttributes: {
				isEntitledConfluenceExternalCollaborator: true,
			},
			productKey,
			siteId: cloudId,
		},
		includeGroups: false,
		includeTeams: false,
		includeUsers: true,
		maxNumberOfResults,
		performSearchQueryOnly: false,
		query,
	};

	return getUserRecommendations(requestParams, intl);
};
